/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavingsPlanRecommendationsData {
    getFixupPrototypeFunction() { return SavingsPlanRecommendationsData.fixupPrototype; }

    static newInstance(model: Partial<SavingsPlanRecommendationsData>): SavingsPlanRecommendationsData {
        let obj = Object.assign(new SavingsPlanRecommendationsData(), model);
        SavingsPlanRecommendationsData.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavingsPlanRecommendationsData>): SavingsPlanRecommendationsData {
        if (!model) return null;
        return SavingsPlanRecommendationsData.newInstance(<SavingsPlanRecommendationsData> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavingsPlanRecommendationsData) {
        if (!obj) return;

        models.SavingsPlanRecommendationsData.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavingsPlanRecommendationsData): boolean {
        Object.setPrototypeOf(obj, SavingsPlanRecommendationsData.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.recommendations) {
            for (let val of this.recommendations) {
                models.SavingsPlanRecommendation.fixupPrototype(val);
            }
        }
    }

    /**
     * Savings plan purchase recommendations.
     */
    recommendations: Array<models.SavingsPlanRecommendation>;

}
